const ToggleSwitch = () => {
	const block = document.querySelectorAll(".toggle-switch");
	if (!block) {
		return;
	}

	block.forEach((el) => {
		const toggle = el.querySelector(".toggle-switch__icon");
		const planParent = el.closest("[data-plan]");

		toggle.addEventListener("click", (e) => {
			const initValue = e.target.getAttribute("data-state-init");
			const activeValue = e.target.getAttribute("data-state-active");

			if (el.classList.contains("active")) {
				el.classList.remove("active");
				planParent.setAttribute("data-plan", initValue);
			} else {
				el.classList.add("active");
				planParent.setAttribute("data-plan", activeValue);
			}
		});
	});
};

export default ToggleSwitch;
